import formatTime from '@/utils/formatTime'
import Constant from "@/assets/js/Constant";
import {mapGetters} from 'vuex';

let filters = {
  formatNumber(val) {
    return (val !== null && Number(val) >= 0) ? Number(val).toFixed(2) : '--'
  },
  formatMoney(val) {
    let result = '--'
    if (val !== null) {
      result = Number(val).toFixed(2) || 0.00 + '元'
    }
    return result
  },
  formatTime(val) {
    return val === null || val === 0 ? '--' : formatTime(val)
  },
  formatDate(val) {
    if (val === undefined || val === null || Number(val) <= 0) {
      return '--'
    }
    return formatTime(val).substring(0, 10)
  },
  /**
   * 根据apkId，获取apk名称
   * @param apkId
   */
  formatApkName(apkId) {
    return methods.formatApkName(apkId);
  },
  /**
   * 根据orderType，获取orderType名称
   * @param orderType
   */
  formatOrderTypeName(orderType) {
    return methods.formatOrderTypeName(orderType);
  },
  /**
   * 根据phoneOs，获取phoneOs名称
   * @param phoneOs
   */
  formatPhoneOsName(phoneOs) {
    return methods.formatPhoneOsName(phoneOs);
  },
  parseDeviceStr(str) {
    let parseJson = methods.parseJson(str);
    return parseJson.device + '台电脑';
  },
  parseDeviceAndPhoneStr(str) {
    let parseJson = methods.parseJson(str);
    return parseJson.device + '台电脑,'+parseJson.phone+'台手机';
  },
}

let methods = {
  parseJson(str) {
    return JSON.parse(str);
  },
  formatHongshanUrl(url) {
    const host = window.location.host
    if (host.indexOf('test') > -1 || host.indexOf('hspc') > -1) {
      return 'http://testhongshan.soouya.com' + url;
    } else if (host.indexOf('local') > -1) {
      return 'http://localhongshan.soouya.com' + url;
    } else {
      return 'http://hongshan.soouya.com' + url;
    }
  },
  formatNumber(row, column) {
    let val = row[column.property]
    return (val !== null && Number(val) >= 0) ? Number(val).toFixed(2) : '--'
  },
  formatMoney(row, column) {
    let val = row[column.property]
    let result = '--'
    if (val !== null) {
      result = Number(val).toFixed(2) || 0.00 + '元'
    }
    return result
  },
  formatTime(row, column) {
    let val = row[column.property]
    return val === null || val === 0 ? '--' : formatTime(val)
  },
  formatDate(row, column) {
    let val = row[column.property]
    if (val === undefined || val === null) {
      return ''
    }
    return formatTime(val).substring(0, 10)
  },
  /**
   * 根据apkId，获取apk名称
   * @param apkId
   */
  formatApkName(apkId) {
    let apkList = Constant.apkList;
    for (let name in apkList) {
      let tempApkId = apkList[name];
      if (tempApkId == apkId) {
        return name;
      }
    }
    return '';
  },
  /**
   * 根据orderType，获取orderType名称
   * @param orderType
   */
  formatOrderTypeName(orderType) {
    let orderTypeList = Constant.orderTypeList;
    for (let name in orderTypeList) {
      let tempOrderType = orderTypeList[name];
      if (tempOrderType == orderType) {
        return name;
      }
    }
    return '';
  },
  /**
   * 根据phoneOs，获取phoneOs名称
   * @param phoneOs
   */
  formatPhoneOsName(phoneOs) {
    let phoneOsList = Constant.phoneOsList;
    for (let name in phoneOsList) {
      let tempPhoneOs = phoneOsList[name];
      if (tempPhoneOs == phoneOs) {
        return name;
      }
    }
    return '';
  },
  formatMSpecId(row) {
    let value = row.extendJson;
    let type = row.type;
    if (type == 5 || value == null || value == '') {
      return;
    }
    let json = JSON.parse(value);
    let reg = /\d+[x|X]\d+/gi
    // console.log(json)
    if(reg.test(json.goodsOutlineText)) {
        let sizeType = json.goodsOutlineText.match(reg)[0];
        let mSpecVal = json.goodsName + "(" + sizeType + ")";
        mSpecVal = mSpecVal === undefined || mSpecVal === null ? '' : mSpecVal;
        let bg = json.bgColorName === undefined || json.bgColorName === null ? '' : '(' + json.bgColorName + ')';
      return mSpecVal + bg;
    }
    else {
      let mSpecVal = Constant.mSpecIds[json.mSpecId];

      // let mSpecVal = json.mSpecName + "(" + sizeType + ")"
      mSpecVal = mSpecVal === undefined || mSpecVal === null ? '' : mSpecVal;
      let bg = json.bgColorName === undefined || json.bgColorName === null ? '' : '(' + json.bgColorName + ')';
      return mSpecVal + bg;
    }
  },
  formatDict(dictTypeList, dictType) {
    const list = dictTypeList;
    for (let i = 0; i < list.length; i++) {
      for (const j in list[i]) {
        if (list[i].dictValue == dictType) {
          return list[i].dictLabel;
        }
      }
    }
    return '';
  }
}

export default {
  filters: {
    ...filters
  },
  methods: {
    ...methods
  },
  computed: {
    ...mapGetters(['vuexDictsOptions'])
  }
}



// WEBPACK FOOTER //
// ./src/mixin/filters.js